<template>
    <div class="payment__form">
        <form
            v-if="state.currentView === 'BANK_INIT_VIEW' && state.processing != true"
            @submit.prevent="step2"
        >
            <div v-if="state.currency === 'ZAR'">
                <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                    {{ $t("bank.init.select")}}
                </p>
                <primary-select
                    :title="$t('bank.input.bank')"
                    :description-text="$t('bank.select.description')"
                    @value-change="sa_bank = $event"
                    :options="state.sa_banks"
                    :defaultValue="
                        getValueFromPath(state, 'inputs.sa_bank.value') || null
                    "
                    inputName="bank"
                />
                <div v-if="state.isHighRisk" class="customer-id__wrapper container__col-md-12 container__col-sm-12">
                    <div class="customer-id__label-row">
                        <span class="customer-id__label-text">Customer ID</span>
                        <div class="customer-id__tooltip-trigger">
                            <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_cid_tooltip)">
                                    <path d="M6.99967 11.6041C9.81863 11.6041 12.1038 9.31893 12.1038 6.49998C12.1038 3.68103 9.81863 1.39581 6.99967 1.39581C4.18072 1.39581 1.89551 3.68103 1.89551 6.49998C1.89551 9.31893 4.18072 11.6041 6.99967 11.6041Z" stroke="#4F4F4F" stroke-width="1.02083" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7 3.44848V3.4375" stroke="#4F4F4F" stroke-width="1.02083" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7 5.47919V9.56252" stroke="#4F4F4F" stroke-width="1.02083" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_cid_tooltip">
                                        <rect width="12.25" height="12.25" fill="white" transform="translate(0.875 0.375)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <div class="customer-id__tooltip">
                                <p>This is a South African Identity or Passport Number</p>
                            </div>
                        </div>
                    </div>
                    <primary-input
                        title="Customer ID"
                        class="customer-id__input"
                        inputName="customer_identifier"
                        :isRequired="true"
                        :total-characters="13"
                        prefix-image="account-number"
                        placeholder="Enter your Customer ID"
                        :error-message="customerIdError"
                        @value-change="customer_identifier = $event"
                    />
                </div>
                <PrimaryButton
                    :content="
                        [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                            .filter(Boolean)
                            .join(' ')
                    "
                    :disabled="!sa_bank || (state.isHighRisk && (customer_identifier.length < 6 || !!customerIdError))"
                    type="submit"
                />
            </div>
            <div v-else-if="state.currency === 'NGN'">
                <div class="account-box">
                    <div class="amount-info-excess">
                        <svg width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15"><path d="M6.987 0.582a6.987 6.987 0 1 0 0 13.976 6.987 6.987 0 0 0 0 -13.976m1.455 10.83q-0.538 0.211 -0.861 0.324t-0.747 0.111q-0.652 0 -1.016 -0.318a1.035 1.035 0 0 1 -0.36 -0.81q0 -0.189 0.026 -0.39 0.027 -0.197 0.087 -0.449l0.45 -1.59q0.06 -0.229 0.102 -0.432a1.95 1.95 0 0 0 0.039 -0.375q0 -0.304 -0.124 -0.423 -0.128 -0.12 -0.48 -0.12a1.2 1.2 0 0 0 -0.36 0.054 4.5 4.5 0 0 0 -0.312 0.105l0.12 -0.491q0.441 -0.18 0.844 -0.309 0.405 -0.129 0.764 -0.129 0.648 0 1.001 0.315 0.351 0.312 0.351 0.813 0 0.104 -0.024 0.364 -0.022 0.262 -0.09 0.48l-0.447 1.585a4.5 4.5 0 0 0 -0.099 0.435q-0.045 0.244 -0.044 0.37 0 0.315 0.141 0.43 0.143 0.115 0.491 0.115a2.1 2.1 0 0 0 0.669 -0.158l-0.12 0.488Zm-0.08 -6.435a1.05 1.05 0 0 1 -0.754 0.291 1.08 1.08 0 0 1 -0.758 -0.291 0.93 0.93 0 0 1 -0.315 -0.705q0 -0.414 0.315 -0.71a1.08 1.08 0 0 1 0.758 -0.294q0.441 0 0.754 0.294 0.315 0.295 0.315 0.708 0 0.414 -0.315 0.705Z" fill="#F5A623"/></svg>
                        <div>
                            <p>To complete your payment, you will need one of the following: </p>
                            <br>
                            <ul>
                                <li>Your internet banking login details</li>
                                <li>A one-time token</li>
                            </ul>
                            <br>
                        </div>
                    </div>
                </div>
                <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                    {{ $t("bank.init.select")}}
                </p>
                <primary-select
                    :title="$t('bank.input.bank')"
                    :description-text="$t('bank.select.description')"
                    @value-change="bank = $event"
                    :options="ng_banks"
                    :defaultValue="
                        getValueFromPath(state, 'inputs.bank.value') || null
                    "
                    inputName="bank"
                />
                <PrimaryButton
                    :content="
                        [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                            .filter(Boolean)
                            .join(' ')
                    "
                    :disabled="bank == '' || bank == null ? true : false"
                    type="submit"
                />
            </div>
            <div v-else-if="state.currency === 'EUR' || state.currency === 'GBP'">
                <primary-select
                    :title="$t('bank.input.country')"
                    :description-text="$t('ui.input.choose')"
                    @value-change="country = $event"
                    :options="eur_countries"
                    inputName="country"
                />
                <PrimaryButton
                    type="submit"
                    :content="
                        [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                            .filter(Boolean)
                            .join(' ')
                    "
                    :disabled="hasCompletedFields === false"
                />
            </div>
            <div v-else>
                <p
                    class="container__col-md-12 container__col-sm-12 payment__instruction"
                >
                    {{ $t("bank.title.description")}}
                </p>
                <primary-select
                    :title="$t('bank.input.bank')"
                    v-if="getValueFromPath(state, 'inputs.bank') || false"
                    :description-text="$t('ui.input.choose')"
                    inputName="bank"
                    :isRequired="getValueFromPath(state, 'inputs.bank.required') || true"
                    @value-change="bank = $event"
                    :options="state.banks"
                />
                <primary-input
                    :title="$t('bank.input.account')"
                    :number-only="true"
                    v-if="getValueFromPath(state, 'inputs.account_number') || false"
                    class="container__col-md-12 container__col-sm-12"
                    inputName="account_number"
                    :isRequired="
                        getValueFromPath(state, 'inputs.account_number.required') || true
                    "
                    type="tel"
                    prefix-image="account-number"
                    placeholder="0123456789"
                    @value-change="accountNumber = $event"
                />
                <primary-input
                    :title="$t('bank.input.phone')"
                    v-if="getValueFromPath(state, 'inputs.account_phone') || false"
                    class="container__col-md-12 container__col-sm-12"
                    inputName="account_phone"
                    :isRequired="
                        getValueFromPath(state, 'inputs.account_phone.required') || true
                    "
                    :defaultValue="
                        getValueFromPath(state, 'inputs.account_phone.value') || null
                    "
                    type="tel"
                    :number-only="true"
                    prefix-image="smart-phone"
                    placeholder="0800000000"
                    @value-change="telephone = $event"
                />
                <primary-input
                    title="BVN"
                    v-if="getValueFromPath(state, 'inputs.account_bvn') || false"
                    class="container__col-md-12 container__col-sm-12"
                    inputName="account_bvn"
                    :isRequired="
                        getValueFromPath(state, 'inputs.account_bvn.required') || true
                    "
                    :defaultValue="
                        getValueFromPath(state, 'inputs.account_bvn.value') || null
                    "
                    type="tel"
                    :number-only="true"
                    prefix-image="password"
                    placeholder="00000000000"
                    @value-change="bvn = $event"
                />
                <primary-input
                    :title="$t('bank.input.dob')"
                    v-if="getValueFromPath(state, 'inputs.account_dob') || false"
                    class="container__col-md-12 container__col-sm-12"
                    :isRequired="
                        getValueFromPath(state, 'inputs.account_dob.required') || true
                    "
                    type="date"
                    inputName="account_dob"
                    prefix-image="credit-card"
                    placeholder="DD/MM/YYYY"
                    @value-change="dob = $event"
                />
                <primary-input
                    :title="$t('bank.input.otp')"
                    v-if="getValueFromPath(state, 'inputs.account_otp.required') || false"
                    class="container__col-md-12 container__col-sm-12"
                    prefix-image="padlock"
                    placeholder="123456"
                    type="tel"
                    :isRequired="getValueFromPath(state, 'inputs.account_otp.required') || true"
                    @value-change="otp = $event"
                    inputName="otp"
                    :number-only="true"
                />
                <div v-if="getValueFromPath(state, 'inputs.account_otp.required') || false" class="container--row container__col-md-12 container__col-sm-12">
                    <p class="otp-instruction">Dial  <a :href="`tel://*822*999*0# `" rel="nofollow">*822*999*0#</a> on your mobile number to get OTP.</p>
                </div>
                <primary-input
                    :title="$t('bank.input.address')"
                    @value-change="address = $event"
                    :isRequired="getValueFromPath(state, 'inputs.address.required') || true"
                    v-if="getValueFromPath(state, 'inputs.address') || false"
                    inputName="address"
                    class="container__col-md-12 container__col-sm-12"
                    prefix-image="location"
                    placeholder="20 Saltlake Edorado"
                    :postfix-image="false"
                />
                <div class="container--row">
                    <div class="container__col-md-8 container__col-sm-8">
                        <primary-input
                            :title="$t('bank.input.city')"
                            @value-change="city = $event"
                            :date="false"
                            inputName="city"
                            v-if="getValueFromPath(state, 'inputs.city') || false"
                            :isRequired="
                                getValueFromPath(state, 'inputs.city.required') || true
                            "
                            class="container__col-md-12 container__col-sm-12"
                            prefix-image="building"
                            placeholder="Livingson"
                        />
                    </div>
                    <div class="container__col-md-4 container__col-sm-4">
                        <primary-input
                            :title="$t('bank.input.postarea')"
                            :total-characters="2"
                            @value-change="userState = $event"
                            inputName="state"
                            v-if="getValueFromPath(state, 'inputs.state') || false"
                            :isRequired="
                                getValueFromPath(state, 'inputs.state.required') || true
                            "
                            class="container__col-md-12 container__col-sm-12"
                            prefix-image="state"
                            placeholder="CA"
                        />
                    </div>
                </div>
                <div class="container__col-md-8 container__col-sm-8">
                    <primary-input
                        :title="$t('bank.input.postcode')"
                        @value-change="zip = $event"
                        :date="false"
                        inputName="zip"
                        type="tel"
                        v-if="getValueFromPath(state, 'inputs.postal_code') || false"
                        :isRequired="
                            getValueFromPath(state, 'inputs.postal_code.required') || true
                        "
                        class="container__col-md-12 container__col-sm-12"
                        prefix-image="zip-code"
                        placeholder="928302"
                    />
                </div>
                <PrimaryButton
                    type="submit"
                    :content="
                        [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                            .filter(Boolean)
                            .join(' ')
                    "
                    :disabled="hasCompletedFields === false"
                />
            </div>
        </form>
        <form
            v-else-if="
                state.currentView == 'BANK_OTP_VIEW' && state.processing !== true
            "
            @submit.prevent="submitOtp"
        >
            <p
                v-html="instructions"
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            ></p>
            <primary-input
                :title="$t('bank.otp.pin')"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="smart-phone"
                placeholder="123456"
                type="tel"
                :isRequired="getValueFromPath(state, 'inputs.otp.required') || true"
                @value-change="otp = $event"
                inputName="otp"
                :number-only="true"
            />
            <PrimaryButton :content="$t('bank.otp.confirm')" type="submit" />
            <div class="container--row container__col-md-12 container__col-sm-12 another-saved">
                <button
                    :disabled="!state.canResendOtp"
                    type="button"
                    aria-label="resend OTP"
                    class="payment__another"
                    role="button"
                    aria-pressed="false"
                    @click="resendOtp"
                >
                    {{ $t("bank.otp.resend") }}
                </button>
            </div>
        </form>
        <template
            v-else-if="
                state.currentView == 'REDIRECT_VIEW' && state.processing != true
            "
        >
            <div class="redirect-wrapper">
                <div class="redirect-icon--arrow">
                    <svg width="33" height="27" viewBox="0 0 33 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.1799 3.13007L18.5799 7.10007L24.7999 6.47007L13.2599 20.5301L4.15988 13.1301L1.62988 16.2201L13.8299 26.1301L27.9799 8.89007L28.6199 15.2501L32.5999 14.8501L31.2799 1.82007L18.1799 3.13007Z" fill="#FFCA7D"/>
                        <path d="M17.0998 1.51996L17.4998 5.47996L23.7098 4.85996L12.1798 18.91L3.0898 11.52L0.549805 14.61L12.7498 24.52L26.8998 7.27996L27.5398 13.64L31.5198 13.24L30.1998 0.209961L17.0998 1.51996Z" fill="black"/>
                        <path d="M0.549805 14.61L1.6298 16.22L13.8298 26.13L12.7498 24.52L0.549805 14.61Z" fill="#703E00"/>
                        <path d="M17.5 5.47998L18.58 7.09999L22.18 6.72998L23.71 4.85999L17.5 5.47998Z" fill="#703E00"/>
                        <path d="M27.54 13.64L28.62 15.25L32.6 14.85L31.52 13.24L27.54 13.64Z" fill="#FFCA7D"/>
                        <path d="M30.1997 0.209961L31.2797 1.81996L32.5997 14.85L31.5197 13.24L30.1997 0.209961Z" fill="#703E00"/>
                    </svg>
                </div>
            </div>
            <p class="container__col-md-12 container__col-sm-12 payment__instruction" v-if="state.currency == 'EUR' || state.currency == 'GBP'">
                <span>{{ $t("bank.redirect.instruction")}}</span>
                <br/>
                <br/>
                <span>{{$t("bank.redirect.expiry.a")}}</span>
                <span class="payment__instruction--duration"><b> {{$t("bank.redirect.duration")}} </b></span>
                <span>{{$t("bank.redirect.expiry.b")}}.</span>
            </p>
            <p class="container__col-md-12 container__col-sm-12 payment__instruction" v-else>
                {{ $t("bank.redirect.instruction")}}
            </p>
            <PrimaryButton :content="$t('ui.redirect.btn')" @click="Next" />
        </template>
        <template v-else-if="state.currentView == 'CONFIRMING_VIEW' && state.processing != true">
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{ (state.currency == 'EUR' || state.currency == 'GBP') ? $t("bank.confirming") : $t("mm.confirming") }}
            </p>
            <div class="center">
                <div class="loader-icon"></div>
            </div>
        </template> 
    </div>
</template>

<script>
import { loadAnimation } from "lottie-web";
import { ref, watch, computed, onBeforeUnmount, onUpdated } from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath, getCodeFromString, autoInitialize } from "@/support/helpers";

import loading from "@/assets/lottie/loading";
import PrimarySelect from "@/components/form/base-select";
import PrimaryButton from "@/components/form/base-button";
import PrimaryInput from "@/components/form/base-input";

export default {
    name: "BankPayment",
    components: {
        PrimaryInput,
        PrimaryButton,
        PrimarySelect,
    },
    setup() {
        const eur_countries = [
            { name: "Austria", code: "AT" },
            { name: "Belgium", code: "BE" },
            { name: "United Kingdom", code: "GB" },
            { name: "Denmark", code: "DK" },
            { name: "Estonia", code: "EE" },
            { name: "Finland", code: "FI" },
            { name: "France", code: "FR" },
            { name: "Germany", code: "DE" },
            { name: "Ireland", code: "IE" },
            { name: "Italy", code: "IT" },
            { name: "Latvia", code: "LV" },
            { name: "Lithuania", code: "LT" },
            { name: "Norway", code: "NO" },
            { name: "Poland", code: "PL" },
            { name: "Portugal", code: "PT" },
            { name: "Spain", code: "ES" },
            { name: "Sweden", code: "SE" },
            { name: "Netherlands", code: "NL" },
        ];

        const store = injectStore();
        const bank = ref("");
        const sa_bank = ref("");
        const country = ref("");
        const customer_identifier = ref("");
        const checkoutData = ref(store.getState());
        const transactionSuccessful = ref(false);
        const showAccount = ref(false);
        const showCopied = ref(false);
        const time = ref(null);
        const otp = ref("");
        const dob = ref("");
        const bvn = ref("");
        const address = ref("");
        const city = ref("");
        const userState = ref("");
        const zip = ref("");
        const telephone = ref(
            getValueFromPath(
                checkoutData.value,
                "view.context.inputs.account_phone.value",
            ) || null,
        );
        const accountNumber = ref(
            getValueFromPath(
                checkoutData.value,
                "view.context.inputs.account_number.value",
            ) || null,
        );
        const ng_banks = [
            { name: "Standard Chartered", code: "068" },
            { name: "First Bank", code: "011" },
            { name: "GTBank", code: "058" },
            { name: "Fidelity Bank", code: "070" },
            { name: "Providus Bank", code: "101" },
            { name: "ALAT by WEMA", code: "035" },
            { name: "Access Bank", code: "044" },
            { name: "Kuda bank", code: "50211" },
            { name: "Standbic IBTC Bank", code: "039" },
            { name: "Union Bank of Nigeria", code: "032" },
            { name: "Opay", code: "999991" },
            { name: "Paga", code: "100002" },
            { name: "Pocket", code: "100033" },
        ]; //TODO: Review to use nigerianbanks.js list

        const customerIdError = computed(() => {
            if (customer_identifier.value && customer_identifier.value.length < 6) {
                return "Customer ID must be between 6 and 13 characters";
            }
            return "";
        });

        // The PWB partner rejects the charge without a valid ISO 3166-1 alpha-2
        // billing country, so keep the pay button disabled until we have one.
        const hasCompletedFields = computed(() => {
            const currency = checkoutData.value.currency.current;
            if (currency === "EUR" || currency === "GBP") {
                return /^[A-Za-z]{2}$/.test(String(country.value?.code || "").trim());
            }
            return ["ZAR", "NGN"].includes(currency);
        });
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });
        watch(bank, (newVal, OldVal) => {
            if (newVal !== "" && OldVal !== null && newVal !== OldVal) {
                const data = { bank: newVal };
                checkoutData.value.view.context.$actions.update(data);
            }
        });
        watch(sa_bank, (newVal, OldVal) => {
            if (newVal !== OldVal) {
                const data = { sa_bank: newVal };
                checkoutData.value.view.context.$actions.update(data);
            }
        });
        watch(customer_identifier, (newVal, OldVal) => {
            if (newVal !== OldVal) {
                checkoutData.value.view.context.$actions.update({ customer_identifier: newVal });
            }
        });
        watch(country, (newVal, OldVal) => {
            if (newVal !== OldVal) {
                checkoutData.value.view.context.$actions.update({ country: newVal });
            }
        });
        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        const timer = computed(() => {
            let time = "";
            if (checkoutData.value.view.context.timerCurrent) {
                let duration = checkoutData.value.view.context.timerCurrent.time;
                let minutes = Math.floor(duration / 60);
                let seconds = duration % 60;
                time = `expires in ${minutes}mins ${seconds}secs`;
            }
            return time;
        });
        function submitOtp() {
            checkoutData.value.view.context.$actions.update({ otp: otp.value });
            Next();
        }
        function resendOtp() {
            checkoutData.value.view.context.resendOTP();
        }
        function step2() {
            let data;
            if (checkoutData.value.currency.current !== "NGN") {
                data = {
                    address: address.value || "",
                    state: userState.value,
                    city: city.value,
                    postal_code: zip.value,
                    country: country.value || null,
                };
            }
            else {
                let date = dob.value.split("-").reverse().join("");
                data = {
                    account_number: accountNumber.value,
                    account_phone: telephone.value,
                    account_dob: date,
                    account_bvn: bvn.value,
                    account_otp: otp.value,
                };
            }

            checkoutData.value.view.context.$actions.update(data);
            sa_bank.value = null;
            bank.value = null;
            Next();
        }
        function loadLottie() {
            loadAnimation({
                container: time.value,
                renderer: "svg",
                loop: true,
                autoplay: true,
                animationData: loading,
                rendererSettings: {
                    progressiveLoad: true,
                    hideOnTransparent: true,
                },
            });
        }
        watch(checkoutData, (val) => {
            if ( val.view != undefined &&
                val.view.current == "BANK_DETAILS_VIEW" &&
        checkoutData.value.processing != true
            ) {
                Next();
            }
        });

        // This works now => AutoInitialize using the helpers auto-initialise methods
        /**
         * ToDo:
         * Fix view to show error when amount is less than 200
         * after new checkout runtime!
         */

        const autoInitializePayment = autoInitialize("BANK_INIT_VIEW");

        const bankPaymentConditions = (checkoutData) => (["ZAR", "NGN", "EUR", "GBP"].includes(checkoutData.value.currency.current));

        onUpdated(() =>  {
            if(!["ZAR", "NGN", "EUR", "GBP"].includes(checkoutData.value.currency.current)){
                autoInitializePayment(checkoutData, Next, bankPaymentConditions);
            } 
        });
        
        if (
            checkoutData.value.processing != true &&
            checkoutData.value.view != undefined &&
            checkoutData.value.view.current == "BANK_DETAILS_VIEW"
        ) {
            loadLottie();
        }
        const instructions = computed(() => {
            const instruction = getCodeFromString(
                checkoutData.value.view.context.instruction,
            );
            return instruction;
        });

        onBeforeUnmount(() => {
            if (checkoutData.value.view.current == "REDIRECT_VIEW" && ["ZAR", "NGN"].includes(checkoutData.value.currency.current)) {
                checkoutData.value.view.context.resetView();
            }
            subscription();
        });
        return {
            state: mapState({
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
                amount: (state) => getValueFromPath(state, "amount") || null,
                processing: (state) => getValueFromPath(state, "processing") || false,
                error: (state) => getValueFromPath(state, "error") || null,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
                banks: (state) =>
                    getValueFromPath(state, "view.context.inputs.bank.options") || [],
                sa_banks: (state) =>
                    getValueFromPath(state, "view.context.inputs.sa_bank.options") || [],
                isHighRisk: (state) =>
                    getValueFromPath(state, "view.context.isHighRisk") === true,
                bankDetails: (state) =>
                    getValueFromPath(state, "view.context.details") || {},
                instructions: (state) =>
                    getValueFromPath(state, "view.context.instruction") || null,
                inputs: (state) => getValueFromPath(state, "view.context.inputs") || {},
                canResendOtp: (state) =>
                    getValueFromPath(state, "view.context.canResendOTP") || false,
            }),
            checkoutData,
            bank,
            otp,
            dob,
            bvn,
            sa_bank,
            customer_identifier,
            customerIdError,
            country,
            eur_countries,
            showAccount,
            telephone,
            accountNumber,
            instructions,
            showCopied,
            getValueFromPath,
            transactionSuccessful,
            city,
            userState,
            zip,
            address,
            hasCompletedFields,
            step2,
            resendOtp,
            submitOtp,
            timer,
            time,
            Next,
            loadLottie,
            ng_banks,
        };
    },
};
</script>

<style lang="scss" scoped>
.timer {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.4rem;
  font-weight: $font-light;
  letter-spacing: 0.3px;
  color: $gray-2;
  margin-bottom: 0;
  padding-top: 2.6rem;
  font-size: 1.2rem;
  border-top: 1px solid #ececec;
}

.account-box {
    padding-bottom: 0;
    margin-bottom: 25px;
}

.amount-info-excess {
    display: flex;
    gap: 10px;
    padding-left: 1.5rem;
    padding-right: 2.8rem;
    margin-bottom: 1.5rem;
}
.amount-info-excess svg {
    flex: 0 0 5%;
    margin-top: 2px;
}
.amount-info-excess {
    div {
        p, ul {
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 17px;
            color: #666666;
            display: block;
            li {
                list-style-type: disc
            }
        }
        ul {
            margin-left: 30px !important;
        }
    }
}
.payment__another {
  width: 140px;
  margin: 0;
  cursor: pointer;
  margin: 0 auto;
  font-size: 1.4rem;
  line-height: 1.4rem;
  text-align: center;
  letter-spacing: 0.3px;
  color: $primary-color;
  background: $white;
  border: none;

  &:focus {
    border: 0.1em solid currentColor;
    outline: $primary-color;
  }
  &:disabled{
    opacity: 0.4;
}
  &.otp {
    &:hover {
      text-decoration: underline;
    }
    &:disabled{
       opacity: 0.4;
    }
  }
}
.another-saved, .otp{
    margin: 2rem 0 0px; 
}
.figure {
  height: 2rem;
}
.otp-instruction{
    font-size: 1.4rem;
    margin-top: -1.8rem;
    margin-bottom: 3rem;
}
.payment__instruction--duration {
    color: red;
 } 

.customer-id__wrapper {
    padding: 0;
}

.customer-id__label-row {
    display: flex;
    align-items: center;
    gap: 0.6rem;
}

.customer-id__label-text {
    text-transform: uppercase;
    font-size: 1.2rem;
    font-weight: $font-bold;
    line-height: 0.9rem;
    color: #919dab;
    margin: 0 0 1rem;
}

.customer-id__tooltip-trigger {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    top: -5px;

    svg {
        display: block;
    }

    &:hover .customer-id__tooltip {
        opacity: 1;
        visibility: visible;
    }
}

.customer-id__tooltip {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    position: absolute;
    left: 2rem;
    top: -1rem;
    width: 26rem;
    background-color: #4F4F4F;
    border-radius: 4px;
    padding: 1.6rem;
    z-index: 99;

    &::before {
        content: "";
        position: absolute;
        border: 6px solid transparent;
        border-right-color: #4F4F4F;
        left: -12px;
        top: 1.4rem;
    }

    p {
        font-size: 1.2rem;
        line-height: 1.8rem;
        color: #fff;

        a {
            color: #FFD580;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}

.customer-id__input {
    :deep(.base__label) {
        display: none;
    }

    :deep(.base__input-prefix) {
        display: none;
    }

    :deep(.base__input-wrapper input) {
        padding-left: 1.5rem;
    }
}
</style>